import type { ReactNode } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

interface FormFieldProps {
  label?: string
  htmlFor?: string
  required?: boolean
  error?: string
  hint?: string
  className?: string
  children: ReactNode
}

const FormField = ({
  children,
  className,
  error,
  hint,
  htmlFor,
  label,
  required = false,
}: FormFieldProps) => (
  <div className={classNames(styles.field, className)}>
    {label ? (
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
        {required ? <span className="text-danger"> *</span> : null}
      </label>
    ) : null}

    {children}

    {error ? <span className={styles.error}>{error}</span> : null}
    {!error && hint ? <span className={styles.hint}>{hint}</span> : null}
  </div>
)

export default FormField
